import i18n from '@/i18n'

const ALLOWED_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/gif',
  'image/svg+xml',
  'image/x-icon',
  'image/vnd.microsoft.icon',
])

// Reel clips, never offered to an image field. MP4 always; with server conversion also the other
// common containers. The server re-checks codec and budget, and converts when it can.
export const VIDEO_TYPES = ['video/mp4']
export const CONVERTIBLE_VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/webm', 'video/x-m4v', 'video/x-matroska']

export function validateBrowserAsset(file, allowedTypes = null, maxBytes = null) {
  if (file && CONVERTIBLE_VIDEO_TYPES.includes(file.type) && allowedTypes?.includes(file.type)) {
    const limit = maxBytes || 4 * 1024 * 1024
    if (file.size > limit) return i18n.t('editorV2.core.assets.videoTooLarge', { size: Math.round(limit / 104857.6) / 10 })
    return null
  }
  if (allowedTypes?.some((type) => CONVERTIBLE_VIDEO_TYPES.includes(type))) {
    return allowedTypes.length > 1 ? i18n.t('editorV2.core.assets.videoTypes') : i18n.t('editorV2.core.assets.mp4Only')
  }
  if (!file) return i18n.t('editorV2.core.assets.chooseImage')
  if (!ALLOWED_TYPES.has(file.type)) return i18n.t('editorV2.core.assets.imageTypes')
  if (allowedTypes && !allowedTypes.includes(file.type)) {
    return i18n.t('editorV2.core.assets.imageTypeUnsupported', { type: file.type || i18n.t('editorV2.core.assets.thatFileType') })
  }
  if (file.size > 8 * 1024 * 1024) return i18n.t('editorV2.core.assets.imageTooLarge')
  return null
}

export function newPendingAssetId() {
  const id = globalThis.crypto?.randomUUID?.()
    || 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (character) => {
      const random = Math.floor(Math.random() * 16)
      const value = character === 'x' ? random : ((random & 0x3) | 0x8)
      return value.toString(16)
    })
  return `pending-${id}`
}

export function newPendingRenditionId() {
  return `pending-rendition-${newPendingAssetId().slice('pending-'.length)}`
}

export function previewConfiguration(configuration, assetUrls, assetSrcSets = {}) {
  if (!configuration) return null
  return {
    ...configuration,
    assetUrls,
    assetSrcSets,
  }
}
